import { AuthClient } from '@/lib/auth/client';

export const authClient = new AuthClient({
  apiBaseUrl: import.meta.env.VITE_API_URL,
  // apiBaseUrl: 'https://predictions-api.local.crowncoinscasino.com',
  // apiBaseUrl: 'https://market-api.dev.crowncoinscasino.com',
  firebase: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
  },
  // reCAPTCHA v3 site key for App Check bot protection (sign-in / sign-up).
  // Same Firebase project + web app as Crowncoins, so it reuses that site key.
  appCheckRecaptchaSiteKey: import.meta.env.VITE_RECAPTCHA_SITE_KEY,
});
